import { Button } from '../Button';
import { Container } from '../Container';
import { Div } from '../HTMLElement';
import { useSpeechRecognition } from '../useSpeechRecognition';
import { prettyStringify } from '../util';

export interface SpeechRecognitionProps {}

export const SpeechRecognition = (props: SpeechRecognitionProps) => {
  const { listening, result, supported, toggle } = useSpeechRecognition({
    onResult: (_result) => {
      console.log('onResult', _result);
    },
  });

  return (
    <Container>
      <Div display="flex" gap={3} justifyContent={'center'} marginBottom={4}>
        <Button
          disabled={!supported}
          label={listening ? 'Stop' : 'Start'}
          onClick={toggle}
          size="large"
          title={!supported ? 'Not supported' : undefined}
        />
      </Div>
      <Div marginBottom={4} textAlign="center">
        <h1>{result}</h1>
      </Div>
      {prettyStringify({
        listening: listening,
        result: result,
        supported: supported,
      })}
    </Container>
  );
};
